const DICT = {
    "sentence_helper": {
        "polish": "...lub podać własny:",
        "english": "...or write your own:",
    },
    "choose_example": {
        "polish": "Proszę wybrać przykład...",
        "english": "Please, choose an example...",
    },
    "run_model_request": {
        "polish": "Proszę uruchomić model, aby uzyskać wynik.",
        "english": "Please run the model to see results.",
    },
    "model_error": {
        "polish": "Coś poszło nie tak. Proszę spróbować ponownie.",
        "english": "Something went wrong. Please try again.",
    },
    "app_based_on": {
        "polish": "Aplikacja stworzona na podstawie",
        "english": "Application based on the",
    },
    "ipi": {
        "polish": "Instytut Podstaw Informatyki PAN",
        "english": "Institute of Computer Science PAS",
    },
    "ipi_url": {
        "polish": "https://ipipan.waw.pl",
        "english": "https://ipipan.waw.pl/en/"
    },
    "work_financed_by": {
        "polish": "Praca finansowana przez Ministerstwo Edukacji i Nauki w ramach inwestycji w infrastrukturę badawczą CLARIN-PL.",
        "english": "Work founded by the Polish Ministry of Education and Science as part of the investment in the CLARIN-PL research infrastructure.",
    },
    "run": {
        "polish": "Uruchom",
        "english": "Run",
    }
};

export default DICT;
